import utils from '../../../../../components/Organisms/Form/utils'
import t from '../../../../../translations/main'

const config = utils.injectTranslation({
  id: 'ReverseSolicitationForm',
  path: 'onboarding.forms.CorporateAccount.ReverseSolicitationForm.inputs',
  content: [
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'reverseSolicitation',
            dataList: [
              {
                id: 'reverseSolicitation1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'reverseSolicitation2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
              {
                id: 'reverseSolicitation3',
                label: t('components.forms.labels.notApplicable'),
                value: 'not-applicable',
              },
            ],
            removeLabelEllipsis: true,
            required: true,
          },
        },
      ],
    },
  ],
})

export default config
